// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thread-translation-editor{position:relative;display:block}.thread-translation-editor .nonEditableCover{border-radius:4px}.thread-translation-editor__body{background-color:#fff;border:1px solid #c6c6c6;border-top-left-radius:4px;border-top-right-radius:4px}.thread-translation-editor__footer{display:flex;justify-content:flex-end;align-items:center;background-color:#f8f8f7;border:1px solid #c6c6c6;border-top:none;border-bottom-left-radius:4px;border-bottom-right-radius:4px}", ""]);
// Exports
module.exports = exports;
